
<app-loader></app-loader>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-modal></app-modal>
<router-outlet></router-outlet>